import { patchMe } from "@/lib/auth/auth-api";
import type { CurrentUser } from "@/lib/auth/roles";
import i18n, { SUPPORTED_LANGUAGES, type Language } from "@/lib/i18n/i18n";

/**
 * At sign-in, reconcile the interface with the account: switch to the language
 * it chose, or record the one it is browsing in when it has not chosen yet.
 * Signing in neither waits on nor fails with the save.
 */
export function applyAccountLanguage(me: CurrentUser) {
  if (me.language) {
    void i18n.changeLanguage(me.language);
    return;
  }
  const current = i18n.resolvedLanguage;
  if (SUPPORTED_LANGUAGES.includes(current as Language)) {
    void patchMe({ language: current as Language }).catch(() => {});
  }
}
